<template>
  <div>
    <p class="errMessage" v-if="error">please ensure a valid email</p>
    <input
      type="email"
      v-model="$parent.info[slg]"
      v-if="slg!='slug'"
      class="text-field w-input"
      :class="error?'error':''"
      :placeholder="[fname]"
      @input="validator($event.target.value)"
    />
  </div>
</template>

<script>
import { error } from "util";
export default {
  name: "Email",
  props: ["slg", "fname", "value"],
  data() {
    return {
      domain: "",
      name: "",
      error: false
    };
  },
  methods: {
    validator(el) {
      var email = el.match(/^[\w-%.]+@[\w-]+(?:\.[\w]{2,64})+$/);
      if (!email && el) {
        this.error = true;
      } else {
        this.error = false;
      }
    }
  },
  mounted() {
    this.domain = this.$parent.$parent.activeSite.domain;
    if (this.slg == "slug") {
      this.slugify = this.$parent.info[this.slg];
    }
    var Col = this.$parent.$route.params.col;
    var found = this.$parent.$parent.collections.filter(
      element => element._id == Col
    );
    this.colSlug = found[0].slug;
  }
};
</script>

<style scoped>
.text-field {
  font-family: almoni;
}
.slug-wrap {
  display: flex;
  white-space: nowrap;
}
.slug {
  background-color: transparent;
  border: none;
  margin-top: -17px;
  outline: none;
  color: white;
  font-size: 16px;
  font-weight: 300;
  width: 100%;
}
.light .slug {
  color: black;
}
.errMessage {
  float: right;
  margin-top: -33px;
}
.error {
  background-color: #ffe9ed;
  border: 1px solid salmon;
}
</style>

